import { render } from "./NotificationSettings.vue?vue&type=template&id=2f82c6b2&scoped=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"

import "./NotificationSettings.vue?vue&type=style&index=0&id=2f82c6b2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f82c6b2"]])

export default __exports__